import type {FunctionComponent} from 'react';
import {useMemo} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {useLocation} from '@app/hooks/use-location';

import {LandingSection} from '@tempo/landing';
import type {Article} from '@app/components/faq';
import {LandingSeoFaq} from '@app/components/faq';

export const FAQ: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();

	const articles = useMemo<Article[]>(
		() => [
			{
				title: t('flowlandingpagefaq_text_Qwhatisdeezerflow_standalone-web', {
					ns: 'flow',
				}),
				answer: [
					t('flowlandingpagefaq_text_Awhatisdeezerflow_standalone-web', {
						sprintf: [`href=${getDeezerUrl('/support')}`],
						ns: 'flow',
					}),
				],
				html: true,
			},
			{
				title: t('flowlandingpagefaq_text_Qwhydontiseemyflow_standalone-web', {
					ns: 'flow',
				}),
				answer: [
					t('flowlandingpagefaq_text_Awhydontiseemyflow_standalone-web', {
						ns: 'flow',
					}),
				],
			},
			{
				title: t(
					'flowlandingpagefaq_text_Qhowdoiaddsongstomyflow_standalone-web',
					{ns: 'flow'},
				),
				answer: [
					t('flowlandingpagefaq_text_Ahowdoiaddsongstomyflow_standalone-web', {
						ns: 'flow',
					}),
				],
			},
			{
				title: t(
					'flowlandingpagefaq_text_Qhowdoiaccessflowanditsmoods_standalone-web',
					{ns: 'flow'},
				),
				answer: [
					t(
						'flowlandingpagefaq_text_Ahowdoiaccessflowanditsmoodsmobile_standalone-web',
						{ns: 'flow'},
					),
					t(
						'flowlandingpagefaq_text_Ahowdoiaccessflowanditsmoodsdesktop_standalone-web',
						{ns: 'flow'},
					),
				],
			},
		],
		[t, getDeezerUrl],
	);
	return (
		<LandingSection isContained>
			<LandingSeoFaq articles={articles} />
		</LandingSection>
	);
};
